import React from 'react';
import TypedOrderForm from './TypedOrderForm';

/**
 * Create Copywrite Order — requested by accounting (Ariane, 2026-09-17), built on the KIND
 * form. Product decisions that shape it:
 *   - Function is always Copywriter (no dropdown).
 *   - Location is the single fixed location "Copywrite" (must exist under Locations).
 *   - Set is "Copywrite".
 *   - Billing offers Day / Hourly / KPI like KIND.
 *   - Clients and their default cost centers live in Settings → Order clients → Copywrite.
 */
export const COPYWRITE_ORDER_CONFIG = {
  orderType: 'copywrite',
  title: 'Create Copywrite Order',
  noun: 'Copywrite Order',
  buttonLabel: 'Create Copywrite Order',
  positions: [{ value: 'Copywriter', label: 'Copywriter' }],
  defaultPosition: 'Copywriter',
  fixedPosition: true,
  studio: 'Remote',
  locations: [{ value: 'copywrite', label: 'Copywrite', match: ['CW', 'Copywriting'] }],
  fixedLocation: true,
  set: 'Copywrite',
  billing: ['daily', 'hourly', 'kpi'],
  infoLabel: 'Copywrite Info',
  infoPlaceholder: 'Copywrite-specific information (optional)',
  groupPrefix: 'copywrite',
};

function CreateCopywriteOrder() {
  return <TypedOrderForm config={COPYWRITE_ORDER_CONFIG} />;
}

export default CreateCopywriteOrder;
